import SvgArrowBigClose from 'app/assets/svg/ArrowBigClose';
import { useRouter } from 'next/router';
import React, { FC } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { routes } from 'shared/common/routes';
import { buildRoute } from 'shared/helpers';
import styled from 'styled-components';

interface SearchItemProps {
  rubricName: string;
  rubricId: number;
  searchString: string;
  setIsShowBackground: React.Dispatch<React.SetStateAction<boolean>>;
  setIsShowResults: React.Dispatch<React.SetStateAction<boolean>>;
  mainCategory?: string;
}

export const SearchItem: FC<SearchItemProps> = ({
  rubricName,
  rubricId,
  searchString,
  setIsShowBackground,
  setIsShowResults,
  mainCategory,
}) => {
  const router = useRouter();
  const onClickHandler = () => {
    setIsShowBackground(false);
    setIsShowResults(false);
    if (mainCategory) {
      router.push(`${buildRoute(routes.category, { id: rubricId })}?mainCategory=${mainCategory}`);
    } else {
      router.push(buildRoute(routes.category, { id: rubricId }));
    }
  };

  const highlight = (searchString: any, rubricName: any) => {
    if (!searchString.trim()) {
      return rubricName;
    }
    return rubricName.replace(
      new RegExp(searchString, 'gi'),
      (str: any) => `<span style="color:#8b33ff">${str}</span>`,
    );
  };

  return (
    <ResultItemWrapper onClick={onClickHandler}>
      <ResultItemNameWrapper>
        <ResultItemName>{ReactHtmlParser(highlight(searchString, rubricName))}</ResultItemName>
      </ResultItemNameWrapper>
      <GoToResultIconWrapper>
        <SvgArrowBigClose />
      </GoToResultIconWrapper>
    </ResultItemWrapper>
  );
};

const ResultItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0 14px 0 20px;

  &:hover {
    background-color: var(--whiteLilac);
    opacity: 0.8;
  }

  @media (max-width: 400px) {
    padding: 0;
  }
`;

const ResultItemNameWrapper = styled.div``;

const ResultItemName = styled.span``;

const GoToResultIconWrapper = styled.span`
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.35;
  letter-spacing: normal;
  color: var(--black2);
  opacity: 0.7;
`;
